export default __webpack_public_path__ + "static/media/menu-open-icon.9b738ff5.svg";